import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import React, { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useSelector } from "../../../../redux/store";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  AppBar: {
    backgroundColor: 'transparent',
    borderBottom: '1px solid rgba(124, 154, 169, 0.5)'
  },
  tabsWrapper: {
    display: 'inline-grid',
  },
  tab: {
    '&.Mui-selected': {
      color: '#FFF'
    }
  }
}));

type PropsType = {
  value: number,
  setValue: (value: number) => void
  building: Array<any>
}

const TabsBuilding: FC<PropsType> = ({ value, setValue, building}) => {
  const classes = useStyles()
  const unitImagesByCompanyId = useSelector(
    (state) => state.unitImagesReducer.unitImagesByCompanyId
  )
  const handleChange = (event: React.ChangeEvent<{}>, index: number) => {
    setValue(index);
  };

  const getLabel = (id: string, name: string) => {
    const count = unitImagesByCompanyId
      .filter((item) => item.property === id).length
    return `${name} (${count})`
  }

  return (
    <AppBar position="static" className={classes.AppBar}>
      <div className={classes.tabsWrapper} id="tab-wrapper">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="secondary"
          scrollButtons="auto"
          variant="scrollable"
          TabIndicatorProps={{
            style: {
              backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
              height: '4px',
              borderRadius: '4px 4px 0 0'
            },
          }}
        >
          {building.map((i, index) => {
            return (
              <Tab
                className={classes.tab}
                label={getLabel(i.id, i.name)}
                key={index}
                value={index}
              />
            )
          })}
        </Tabs>
      </div>
    </AppBar>
  )
}

export default TabsBuilding
